import React, { ReactNode } from 'react';
import styled from 'styled-components';

type ProgressCircleProps = {
  progress: number;
  size: number;
  strokeWidth: number;
  backgroundColor?: string;
  unfilledColor?: string;
  children?: ReactNode;
};

export const ProgressCircle = ({
  progress,
  size,
  strokeWidth,
  backgroundColor = '#ceeedb',
  unfilledColor = '#fff',
  children,
}: ProgressCircleProps): JSX.Element => {
  const innerCircleSize = size - strokeWidth * 2;

  return (
    <OuterCircle
      $size={size}
      $strokeWidth={strokeWidth}
      $unfilledColor={unfilledColor}
      style={{ '--progress': progress } as React.CSSProperties}
    >
      <InnerCircle $size={innerCircleSize} $backgroundColor={backgroundColor}>
        {children}
      </InnerCircle>
    </OuterCircle>
  );
};

const OuterCircle = styled.div<{ $unfilledColor: string; $size: number }>`
  --progress: 0;
  align-items: center;
  background: conic-gradient(
    #00624a calc(var(--progress) * 1%),
    ${({ $unfilledColor }) => $unfilledColor} calc(var(--progress) * 1%)
  );
  border-radius: 50%;
  display: flex;
  flex-shrink: 0;
  height: ${({ $size }) => $size}px;
  justify-content: center;
  transition: --progress 0.5s ease-out;
  width: ${({ $size }) => $size}px;

  @property --progress {
    inherits: false;
    initial-value: 0;
    syntax: '<number>';
  }
`;

const InnerCircle = styled.div<{ $backgroundColor: string; $size: number }>`
  align-items: center;
  background: ${({ $backgroundColor }) => $backgroundColor};
  border-radius: 50%;
  color: #00624a;
  display: flex;
  height: ${({ $size }) => $size}px;
  justify-content: center;
  width: ${({ $size }) => $size}px;
`;
